/* import __COLOCATED_TEMPLATE__ from './confirmation.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { warn } from '@ember/debug';
export let Color = /*#__PURE__*/function (Color) {
  Color["RED"] = "RED";
  Color["GREEN"] = "GREEN";
  Color["BLUE"] = "BLUE";
  Color["GRAY"] = "GRAY";
  return Color;
}({});
export let Icon = /*#__PURE__*/function (Icon) {
  Icon["LOADING"] = "LOADING";
  Icon["CHECK"] = "CHECK";
  Icon["QUESTION"] = "QUESTION";
  Icon["X"] = "X";
  Icon["WARNING"] = "WARNING";
  Icon["INFO"] = "INFO";
  return Icon;
}({});

// TODO(steckel): Prefer `instanceof SafeString` to the assumptions below.
// Ember doesn't currently expose SafeString for us to instanceof check with.

const isStringCompatible = candidate => typeof candidate === 'string' || typeof candidate === 'object' && candidate != null && typeof candidate['toString'] === 'function';
function normalizeBodyArgument(body) {
  if (body == null) {
    return [];
  }
  if (Array.isArray(body) && body.every(isStringCompatible)) {
    return body;
  }
  if (isStringCompatible(body)) {
    return [body];
  }
  throw new TypeError('body argument is not a valid undefined | null | string | SafeString | Array<string | SafeString>');
}
export default class Confirmation extends Component {
  // TODO(steckel): consider asserting runtime that Args types are correct.
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "Icon", Icon);
    _defineProperty(this, "body", void 0);
    if (args.color == null) {
      throw new TypeError('color argument cannot be null or undefined');
    }
    if (Color[args.color] == null) {
      throw new TypeError('color argument is not a valid Color');
    }
    if (args.icon == null) {
      throw new TypeError('icon argument cannot be null or undefined');
    }
    if (Icon[args.icon] == null) {
      throw new TypeError('icon argument is not a valid Color');
    }
    this.body = normalizeBodyArgument(args.body);
    warn('Banking::Confirmation has been deprecated in favor of Banking::Common::Confirmation', false, {
      id: '@banking.ui.confirmation'
    });
  }
  get iconModifierClass() {
    switch (this.args.color) {
      case Color.RED:
        return 'banking-confirmation__icon--red';
      case Color.GREEN:
        return 'banking-confirmation__icon--green';
      case Color.BLUE:
        return 'banking-confirmation__icon--blue';
      case Color.GRAY:
        return 'banking-confirmation__icon--gray';
    }
  }
  get iconPath() {
    switch (this.args.icon) {
      case Icon.LOADING:
        return null;
      case Icon.CHECK:
        return '36px-check';
      case Icon.QUESTION:
        return '36px-question';
      case Icon.X:
        return '16px-circle-close';
      case Icon.WARNING:
        return '18px-alert';
      case Icon.INFO:
        return '16px-info-circle-stroked';
    }
  }
}